import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { UIInstance } from '../../cvp-webgames-core/UI/UiManager';
import { setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import { UIProperties } from '../UIProperties';
import ContnueButton from './ContinueButton';
import './NurseStationComputerUI.css'

const NurseStationComputerUI = (props: UIProperties<NurseStationComputerUIConfig>) => {
	const [tabButtonReportsLeaveOn, setTabButtonReportsLeaveOn] = useState(false);
	const [tabButtonReviewLeaveOn, setTabButtonReviewLeaveOn] = useState(false);
	const [tabButtonReflectLeaveOn, setTabButtonReflectLeaveOn] = useState(false);
	const [enabledTabIndx, setEnabledTabIndx] = useState(-1);
	const enableTabItem = (indx: number, updateFocus: boolean) => {
		if(enabledTabIndx === indx) {
			return;
		}

		if(indx > 2) {
			indx = 0;
		}

		switch(indx) {
			case 0:
				setTabButtonReportsLeaveOn(true);
				setTabButtonReviewLeaveOn(false);
				setTabButtonReflectLeaveOn(false);
				if(updateFocus) {
					setFocus('nurse-station-computer-reports')
				}
				break;
			case 1:
				setTabButtonReportsLeaveOn(false);
				setTabButtonReviewLeaveOn(true);
				setTabButtonReflectLeaveOn(false);
				if(updateFocus) {
					setFocus('nurse-station-computer-review')
				}
				// debugger

				// if(!props.parameters.reports && !props.parameters.reflects) {
				// 	setFocus('nurse-station-container')
				// } else {
				// 	setFocus('nurse-station-computer-review')
				// }
				break;
			case 2:
				setTabButtonReportsLeaveOn(false);
				setTabButtonReviewLeaveOn(false);
				setTabButtonReflectLeaveOn(true);
				if(updateFocus) {
					setFocus('nurse-station-computer-reflect')
				}
				break;
		}


		setEnabledTabIndx(indx);
	};

	if(enabledTabIndx === -1) {
		if(props.parameters.reports) {
			enableTabItem(0, true);
		} else if(props.parameters.review) {
			enableTabItem(1, true);
		} else if(props.parameters.reflects) {
			enableTabItem(2, true);
		}
	}

	return (
		<div className="in-game-ui-container ui-top-most-container modal-bg">
			<div className="nurse-station-container" tabIndex={0} id='nurse-station-computer-first' aria-label='nurse station computer'>
				<img src="./assets/images/general/components/nurse-station-computer/nurse-station-background.png"/>
				{props.parameters.reports && props.parameters.reflects && props.parameters.review ? <div className="nurse-station-tabs-container">
					<GeneralButton parameters= {{
							srcIdle: './assets/images/general/components/nurse-station-computer/tabs/nurse_computer_button_reports_main.png',
							srcHighlight: './assets/images/general/components/nurse-station-computer/tabs/nurse_computer_button_reports_down.png',
							top: '42px',
							left: '0px',
							width: '413.33px',
							ariaLbl: 'Reports',
							id:'nurse-station-computer-reports',
							shouldLeaveOn: tabButtonReportsLeaveOn,
							onClicked: () => {
								enableTabItem(0, false);
								setFocus('nurse-station-computer-content')
							}
					}}/>
					<GeneralButton parameters= {{
							srcIdle: './assets/images/general/components/nurse-station-computer/tabs/nurse_computer_button_review_main.png',
							srcHighlight: './assets/images/general/components/nurse-station-computer/tabs/nurse_computer_button_review_down.png',
							top: '42px',
							left: '413.33px',
							width: '413.33px',
							ariaLbl: 'Review',
							shouldLeaveOn: tabButtonReviewLeaveOn,
							id:'nurse-station-computer-review',
							onClicked: () => {
								enableTabItem(1, false);
								setFocus('nurse-station-computer-content')
							}
					}}/>
					<GeneralButton parameters= {{
							srcIdle: './assets/images/general/components/nurse-station-computer/tabs/nurse_computer_button_reflect_main.png',
							srcHighlight: './assets/images/general/components/nurse-station-computer/tabs/nurse_computer_button_reflect_down.png',
							top: '42px',
							left: '826.66px',
							width: '413.33px',
							shouldLeaveOn: tabButtonReflectLeaveOn,
							ariaLbl: 'Reflect',
							id:'nurse-station-computer-reflect',
							onClicked: () => {
								enableTabItem(2, false);
								setFocus('nurse-station-computer-content')
							}
					}}/>
				</div> : (null)}
				<div className="nurse-station-main-content-container">
					{tabButtonReportsLeaveOn ? 
					(<div tabIndex={0} id='nurse-station-computer-content' aria-label='content' className="nurse-station-reports-container nurse-station-main-content-item">
						<div className="nurse-station-reports-item" aria-label={props.parameters.reports[0].title}>
							<img src="./assets/images/general/components/nurse-station-computer/nurse_computer_bar_2.png"/>
							<p className="nurse-station-reports-item-title big-description-font">{props.parameters.reports[0].title}</p>
							<p tabIndex={0} className="nurse-station-reports-item-description regular-description-font" dangerouslySetInnerHTML={{ __html: props.parameters.reports[0].description }}></p>
						</div>

						<div className="nurse-station-reports-item" style={{top: '170px'}} aria-label={props.parameters.reports[1].title}>
							<img src="./assets/images/general/components/nurse-station-computer/nurse_computer_bar_2.png"/>
							<p className="nurse-station-reports-item-title big-description-font">{props.parameters.reports[1].title}</p>
							<p tabIndex={0} className="nurse-station-reports-item-description regular-description-font">{props.parameters.reports[1].description}</p>
						</div>

						<div className="nurse-station-reports-item" style={{top: '340px'}} aria-label={props.parameters.reports[2].title}>
							<img src="./assets/images/general/components/nurse-station-computer/nurse_computer_bar_2.png"/>
							<p className="nurse-station-reports-item-title big-description-font">{props.parameters.reports[2].title}</p>
							<p tabIndex={0} className="nurse-station-reports-item-description regular-description-font">{props.parameters.reports[2].description}</p>
						</div>
					</div>) : (null)}

					{tabButtonReviewLeaveOn ? 
					(<div tabIndex={0} id='nurse-station-computer-content' style={{
						top: props.parameters.review && props.parameters.reports && props.parameters.reflects ? '120px' : '70px',
    					height: props.parameters.review && props.parameters.reports && props.parameters.reflects ? '510px' : '570px'
					}} className="nurse-station-review-container nurse-station-main-content-item" dangerouslySetInnerHTML={{ __html: props.parameters.review.text }}>
					</div>) : (null)}

					{tabButtonReflectLeaveOn ? 
					(<div tabIndex={0} id='nurse-station-computer-content' aria-label='content' className="nurse-station-reflect-container nurse-station-main-content-item">
						{props.parameters.reflects.map((config: NurseStationComputerUIReflectConfig, indx: number) => {
							return (
								<div key={Tools.generateGuid() + indx} className="nurse-station-reflect-single-item-container">
									<div className="nurse-station-reflect-single-item-inner-container">
										<p tabIndex={0} className="big-description-font">{config.title}</p>
										<input tabIndex={0} type="text" placeholder="Enter your answer here" onChange={(event) => {
											props.parameters.reflects[indx].answer = event.target.value;
										}}/>
									</div>
								</div>
							);
						})}
					</div>) : (null)}

					<ContnueButton parameters= {{
						id:'nurse-station-computer-last',
						top: '651px',
						left: '511px',
						width: '190px',
						onClicked: () => {
							if(props.parameters.reports && props.parameters.reflects && props.parameters.review) {
								if(enabledTabIndx === 2) {
									props.parameters.onClosed(props.parameters);
									return;
								}
								enableTabItem(enabledTabIndx+1, false);
								setFocus('nurse-station-computer-content')
							} else {
								props.parameters.onClosed(props.parameters);
							}
						}
					}}/>
				</div>
			</div>
			
		</div>
	);

};

export interface NurseStationComputerUIConfig extends BaseConfig {
	reports: NurseStationComputerUIReportConfig[];
	review: NurseStationComputerUIReviewConfig;
	reflects: NurseStationComputerUIReflectConfig[];
	onClosed: (conig: NurseStationComputerUIConfig) => void;
}

export interface NurseStationComputerUIReportConfig {
	title: string;
	description: string;
}

export interface NurseStationComputerUIReviewConfig {
	text: string;
}

export interface NurseStationComputerUIReflectConfig {
	title: string;
	answer: string;
}

export default NurseStationComputerUI;